<template>
  <div class="app-container">
    <div class="account-container" :class="isCollapse?'account-collapse':''">
      <pang-title :text="$router.lang.get('會員  中心')" eng="Account"/>
      <div class="tab-container">
        <pang-tab
        :tabs="tabs" v-model:current="currentTab"/>
      </div>
      <div class="detail" v-if="currentTab == 0" >
        <div v-if="detailEdit == 0">
          <div class="detail-container">
            <div class="detail-label">{{ $router.lang.get('暱稱：') }}</div>
            <div class="detail-content">{{ screenState.user?screenState.user.nickname:'' }} </div>
            <div v-if="screenState.user && screenState.user.nickname_is_new" class="detail-butt" @click="editDetail(1)">{{ $router.lang.get('修改') }}</div>
          </div>
          <div class="detail-container">
            <div class="detail-label">{{ $router.lang.get('賬號：') }}</div>
            <div class="detail-content">{{ screenState.user?screenState.user.username:'' }} </div>
          </div>
          <div class="detail-container">
            <div class="detail-label">{{ $router.lang.get('信箱：') }}</div>
            <div class="detail-content">{{ screenState.user && screenState.user.email?screenState.user.email:'-' }} </div>
            <div class="detail-butt" @click="editDetail(2)">{{ $router.lang.get(screenState.user && screenState.user.email?'修改':'添加') }}</div>
          </div>
          <div class="checkbox">
            <input type="checkbox" v-model="ads"/>
            <label @click="checking('ads')">{{ $router.lang.get('同意接受 Panggame 消息及廣告訊息') }}</label>
          </div>
          <div class="detail-container">
            <div class="detail-label">{{ $router.lang.get('手機號碼：') }}</div>
            <div class="detail-content">{{ screenState.user && screenState.user.phone?'+' + screenState.user.areacode + screenState.user.phone:'-' }} </div>
            <div class="detail-butt" @click="editDetail(3)">{{ $router.lang.get(screenState.user && screenState.user.phone?'修改':'添加') }}</div>
          </div>
          <div class="checkbox">
            <input type="checkbox" v-model="ads_phone"/>
            <label @click="checking('ads_phone')">{{ $router.lang.get('同意接受在panggame提供的活動抽獎 及遊戲服務同意通知相關sms訊息') }}</label>
          </div>
          <div class="butt-container detail-sumit-butt" v-if="screenState.screenWidth > 1350">
            <div>
              <pang-butt :text="$router.lang.get('取消')" @click="goback()" btype="account-cancel" :loading="loading"/>
            </div>
            <div>
              <pang-butt :text="$router.lang.get('確認')" @click="submit({ads: ads, ads_phone: ads_phone})" btype="account-submit" :loading="loading"/>
            </div>
          </div>
          <div class="butt-container detail-sumit-butt logout" v-else>
            <div>
              <pang-butt :text="$router.lang.get('登出')" @click="logout()" btype="submit" :loading="loading"/>
            </div>
          </div>
        </div>
        <div v-else-if="detailEdit == 1">
          <div class="password-container no-margin-bottom">
            <div class="input-label">{{ $router.lang.get('暱稱：') }}</div>
            <div class="input-container">
              <pang-input 
              :placeholder="$router.lang.get('輸入新暱稱')" ref='nickname' required
              v-model:value="nickname" name="nickname"
              :validate="nicknameValidator"/>
            </div>
          </div>
          <div class="nickname-hint">{{ $router.lang.get('暱稱僅有一次修改機會') }}</div>
          <div class="butt-container">
            <div>
              <pang-butt :text="$router.lang.get('取消')" @click="editDetail(0)" btype="account-cancel" :loading="loading"/>
            </div>
            <div>
              <pang-butt :text="$router.lang.get('確認')" @click="submit({nickname: nickname, nickname_is_new: false})" btype="account-submit" :loading="loading"/>
            </div>
          </div>
        </div>
        <div v-else-if="detailEdit == 2">
          <div v-if="screenState.user.email" class="password-container">
            <div class="input-label">{{ $router.lang.get('舊信箱地址：') }}</div>
            <div class="input-container">
              <pang-sms-input
              buttMsgField="emailButtMsg1"
              buttMsgCountingField="emailButtMsgCounting1"
              ref="emailOld"
              v-model:phone="screenState.user.email"
              v-model:code="emailCodeOld"
              noAreaCode
              :verifySource="2"
              :verifyType="3"
              name="email"
              :inputDisabled="true"
              @enter="nextInput($refs.email)"/>
            </div>
          </div>
          <div class="password-container">
            <div class="input-label">{{ $router.lang.get(screenState.user.email?'新信箱地址：':'信箱地址：') }}</div>
            <div class="input-container">
              <pang-sms-input
              buttMsgField="emailButtMsg2"
              buttMsgCountingField="emailButtMsgCounting2"
              ref="email"
              v-model:phone="email"
              v-model:code="emailCode"
              noAreaCode
              :verifySource="2"
              :verifyType="3"
              name="email"
              :placeholder="$router.lang.get('請輸入新的信箱地址')"
              :validate="screenState.user.email?newEmailValidator:emailValidator"
              @enter="verifyCode({code: emailCode, email: email, verify_source: 2, verify_type: 3})"/>
            </div>
          </div>
          <div class="butt-container">
            <div>
              <pang-butt :text="$router.lang.get('取消')" @click="editDetail(0)" btype="account-cancel" :loading="loading"/>
            </div>
            <div>
              <pang-butt :text="$router.lang.get('確認')" @click="screenState.user.email?changeEmail():verifyCode({code: emailCode, email: email, verify_source: 2, verify_type: 3})" btype="account-submit" :loading="loading"/>
            </div>
          </div>
        </div>
        <div v-else-if="detailEdit == 3">
          <div v-if="screenState.user.phone" class="password-container">
            <div class="input-label">{{ $router.lang.get(screenState.user.phone?'舊手機號碼：':'手機號碼：') }}</div>
            <div class="input-container">
              <pang-sms-input
              buttMsgField="buttMsg1"
              buttMsgCountingField="buttMsgCounting1"
              ref="phoneOld"
              :areacode="screenState.user.areacode"
              :phone="screenState.user.phone"
              v-model:code="codeOld"
              :verifyType="2"
              :inputDisabled="true"
              @enter="nextInput($refs.phone.$refs.phone)"/>
            </div>
          </div>
          <div class="password-container">
            <div class="input-label">{{ $router.lang.get(screenState.user.phone?'新手機號碼：':'手機號碼：') }}</div>
            <div class="input-container">
              <pang-sms-input
              buttMsgField="buttMsg2"
              buttMsgCountingField="buttMsgCounting2"
              ref="phone"
              :hint="$router.lang.get('请输入手机号，不为 0 开头的')"
              v-model:areacode="areacode"
              v-model:phone="phone"
              v-model:code="code"
              :verifyType="2"
              :validate="phoneValidator"
              @enter="usernameChange?nextInput($refs.username):(screenState.user.phone?changePhone():verifyCode({username:username, code: code, areacode: areacode, phone: phone.replace(/^0/, ''), verify_source: 1, verify_type: 2}))"/>
            </div>
          </div>
          <div v-if="usernameChange" class="password-container">
            <div class="input-label">{{ $router.lang.get('賬號：') }}</div>
            <div class="input-container">
              <pang-input
              :placeholder="$router.lang.get('請輸入自訂賬號')" ref='username' required
              :hint="$router.lang.get('賬號第一位必須為英文字母，最多 32 個字元')"
              v-model:value="username" name="username"
              :validate="usernameValidator" @enter="verifyCode({username:username, code: code, areacode: areacode, phone: phone.replace(/^0/, ''), verify_source: 1, verify_type: 2})"/>
            </div>
          </div>
          <div class="butt-container">
            <div>
              <pang-butt :text="$router.lang.get('取消')" @click="editDetail(0)" btype="account-cancel" :loading="loading"/>
            </div>
            <div>
              <pang-butt :text="$router.lang.get('確認')" @click="screenState.user.phone?changePhone():verifyCode({username:username, code: code, areacode: areacode, phone: phone.replace(/^0/, ''), verify_source: 1, verify_type: 2})" btype="account-submit" :loading="loading"/>
            </div>
          </div>
        </div>
      </div>
      <div class="password" v-else-if="currentTab == 1">
        <div class="tab2-container">
          <pang-tab
          :tabs="tabs2" v-model:current="currentTab2"/>
        </div>
        <div class="password-container">
        <div class="input-label">{{ $router.lang.get(tabs2[currentTab2] + '：')}}</div>
        <div class="input-container">
            <div class="sms-container"
                v-if="tabs2[currentTab2] == $router.lang.get('手機')">
                <pang-sms-input
                ref="smsPhone"
                v-model:areacode="screenState.user.areacode"
                v-model:phone="screenState.user.phone"
                v-model:code="codeChangePassword"
                :verifyType="4"
                :inputDisabled="true"
                @enter="nextInput($refs.password2)"
                />
            </div>
            <div v-else class="email-input">
                <pang-sms-input
                ref="smsEmail"
                name="email"
                :noAreaCode="true"
                :verifySource="2"
                v-model:phone="screenState.user.email"
                v-model:code="emailCodeChangePassword"
                :verifyType="4"
                :inputDisabled="true"
                @enter="nextInput($refs.password2)"
                />
            </div>
        </div>
        </div>
        <div class="password-container">
          <div class="input-label">{{ $router.lang.get('輸入新密碼：') }}</div>
          <div class="input-container">
            <pang-input 
            :placeholder="$router.lang.get('密碼')" ref='password2' required
            v-model:value="password2" name="password"
            type="password" :validate="passwordValidator"
            @enter="nextInput($refs.password3)"/>
          </div>
        </div>
        <div class="password-container">
          <div class="input-label">{{ $router.lang.get('確認新密碼：') }}</div>
          <div class="input-container">
            <pang-input 
            :placeholder="$router.lang.get('密碼')" ref='password3' required
            v-model:value="password3" name="password"
            type="password" :validate="passwordValidator"
            @enter="changePassword"/>
          </div>
        </div>
        <div class="butt-container">
          <div>
            <pang-butt :text="$router.lang.get('取消')" @click="goCurrentTab(0)" btype="account-cancel" :loading="loading"/>
          </div>
          <div>
            <pang-butt :text="$router.lang.get('確認')" @click="changePassword" btype="account-submit" :loading="loading"/>
          </div>
        </div>
      </div>
      <div class="password" v-else-if="currentTab == 2">
        <div class="password-container">
          <div class="input-label">{{ $router.lang.get('姓名：') }}</div>
          <div v-if="!(screenState.user && screenState.user.realname && screenState.user.idcard)" class="input-container">
            <pang-input 
            :placeholder="$router.lang.get('請輸入姓名')" ref='realname' required
            v-model:value="realname" name="realname"
            @enter="nextInput($refs.idcard)"/>
          </div>
          <div  v-else class="detail-content">{{ screenState.user?screenState.user.realname:'' }} </div>
        </div>
        <div class="password-container">
          <div class="input-label">EX：</div>
          <div v-if="!(screenState.user && screenState.user.realname && screenState.user.idcard)" class="input-container">
            <pang-input 
            :placeholder="$router.lang.get('請輸入身份證號')" ref='idcard' required
            v-model:value="idcard" name="idcard"
            :validate="idcardValidator"
            @enter="submit({realname: realname, idcard: idcard})"/>
          </div>
          <div  v-else class="detail-content">{{ screenState.user?screenState.user.idcard.slice(0, 2) + '****' + screenState.user.idcard.slice(6, 10) :'' }} </div>
        </div>
        <div class="butt-container" v-if="!(screenState.user && screenState.user.realname && screenState.user.idcard)">
          <div>
            <pang-butt :text="$router.lang.get('取消')" @click="goCurrentTab(0)" btype="account-cancel" :loading="loading"/>
          </div>
          <div>
            <pang-butt :text="$router.lang.get('確認')" @click="submit({realname: realname, idcard: idcard})" btype="account-submit" :loading="loading"/>
          </div>
        </div>
      </div>
      <div class="promotion" v-else-if="currentTab == 3">
          <div>
            <div v-for="item in promoCodes" :key="item.id" class="promo-item higher">
            <div class="promo-detail">
                <div class="promo-img">
                <img :src="item.cover" alt="">
                </div>
                <div class="promo">
                <div class="promo-title">{{ item.promo_name }}</div>
                <div class="promo-subtitle">
                    <div>฿ {{ priceFormat(item.promo_type) }}</div>
                </div>
                </div>
            </div>
            <div class="promo-num">
                <div class="promo-code"><span class="pin-label">Pin:</span> <span :id="'c' + item.promo_code">{{ item.promo_code }}</span></div>
                <div class="promo-butt">
                <pang-butt  :id="'butt' + item.promo_code" data-clipboard-action="copy" :data-clipboard-target="'#c' + item.promo_code" @click="copyCode(item.promo_code)" :text="$router.lang.get('復制')" :style="{fontSize: '14px', height: '26px', padding: '0', lineHeight: '26px', }"/>
                </div>
            </div>
            <div class="promo-num">
                <div class="promo-code"><span class="pin-label">Serial:</span> <span :id="'c' + item.serial">{{ item.serial }}</span></div>
                <div class="promo-butt">
                <pang-butt  :id="'butt' + item.serial" data-clipboard-action="copy" :data-clipboard-target="'#c' + item.serial" @click="copyCode(item.serial)" :text="$router.lang.get('復制')" :style="{fontSize: '14px', height: '26px', padding: '0', lineHeight: '26px', }"/>
                </div>
            </div>
            </div>
        </div>
            <div v-if="!isCollapse && promoCodes.length > 0 && promoCodes2.length > 0" class="gift-spliter">{{ this.$router.lang.get('禮包碼') }}</div>
          <div>
            <div v-for="item in promoCodes2" :key="item.id" class="promo-item">
            <div class="promo-detail">
                <div class="promo-img">
                <img :src="item.cover" alt="">
                </div>
                <div class="promo">
                <div class="promo-title">{{ item.promo_name }}</div>
                <div class="promo-subtitle">
                    <div><img src="../../assets/images/ico_pc_coupon.png" alt=""> PC</div>
                </div>
                </div>
            </div>
            <div class="promo-num">
                <div class="promo-code">{{ $router.lang.get('序號：') }}<span :id="'c' + item.promo_code">{{ item.promo_code }}</span></div>
                <div class="promo-butt">
                <pang-butt  :id="'butt' + item.promo_code" data-clipboard-action="copy" :data-clipboard-target="'#c' + item.promo_code" @click="copyCode(item.promo_code)" :text="$router.lang.get(isCollapse?'復制':'復制券碼')" :style="{fontSize: '14px', height: '26px', padding: '0', lineHeight: '26px', }"/>
                </div>
            </div>
            </div>
        </div>
        <div class="no-data" v-if="promoCodes.length == 0 && promoCodes2.length == 0">
            {{ $router.lang.get('暫無數據') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { useScreenState } from '../../store';
import request from '../../api/request'
import { PangTitle, PangTab, PangInput, PangSmsInput, PangButt } from '../../components'
import validate from '../../utils/validate'
// import browser from '../../utils/browser'
import { pwHash } from '../../utils';
import filters from '../../utils/filters'
import message from '../../utils/message'
import Clipboard from 'clipboard';

export default {
  name: "Account",
  components: {
    PangTitle,
    PangTab,
    PangInput,
    PangSmsInput,
    PangButt,
  },
  data() {
    return {
      loading: false,
      screenState: useScreenState(),
      currentTab: 0,
      detailEdit: 0,
      priceFormat: filters.priceFormat,
      tabs: [
        this.$router.lang.get('我的資料'),
        this.$router.lang.get('密碼更改'),
        this.$router.lang.get('實名認證'),
        this.$router.lang.get('我的禮包'),
      ],
      currentTab2: 0,
      tabs2: [
      ],
      password: '',
      password2: '',
      password3: '',
      nickname: '',
      areacode: '66',
      phone: '',
      code: '',
      codeOld: '',
      codeChangePassword: '',
      email: '',
      emailCode: '',
      emailCodeOld: '',
      emailCodeChangePassword: '',
      ads: false,
      ads_phone: false,
      idcard: '',
      realname: '',
      emailValidator: validate.emailRegister,
      passwordValidator: validate.password,
      idcardValidator: validate.idcard,
      usernameValidator: validate.usernameRegister,
      usernameChange: false,
      username: '',
      promoCodes: [],
      promoCodes2: [],
    }
  },
  beforeMount () {
    if (!this.screenState.user) {
      this.$router.replace({ path: '/account/login', query: {returnurl: this.$route.fullPath}});
    }
    else {
      this.ads = this.screenState.user.ads
      this.ads_phone = this.screenState.user.ads_phone
      this.realname = this.screenState.user.realname
      this.idcard = this.screenState.user.idcard
    }
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
  },
  methods: {
    logout() {
      this.screenState.user = null;
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("user_info");
      let currentPath = this.$route.path;
      let _this = this;
      setTimeout(function () {
        if (currentPath == _this.$route.path)
          window.location = window.location.href;
      }, 3000);
      message.showMessage(this, this.$router.lang.get("登出成功"), "success");
    },
    async phoneValidator (str) {
      if (str == this.screenState.user.areacode + this.screenState.user.phone)
        return this.$router.lang.get('新舊手機號碼完全一樣')
      if (this.screenState.user.username == this.screenState.user.phone) {
        let msg = await validate.phoneAndUsernameRegister(str)
        if (msg == this.$router.lang.get('當前手機號與已有手機號衝突，請自訂賬號'))
          this.usernameChange = true
        else
          this.usernameChange = false
        if (!this.username)
          return msg
      }
      else
        return validate.phoneRegister(str)
    },
    editDetail (n) {
      this.detailEdit = n
    },
    goback () {
      if (this.$router.options.history.state.position == 1)
        this.$router.replace('/home')
      else
        this.$router.back()
    },
    async validate () {
      if (this.currentTab == 0 && this.detailEdit == 1) {
        return await this.$refs.nickname.validateValue(this.nickname)
      }
      if (this.currentTab == 0 && this.detailEdit == 2) {
        return await this.$refs.email.validateValue()
      }
      if (this.currentTab == 0 && this.detailEdit == 3) {
        return await this.$refs.phone.validateValue()
      }
      if (this.currentTab == 1) {
        let v2 = await this.$refs.password2.validateValue(this.password2)
        let v3 = await this.$refs.password3.validateValue(this.password3)
        if (v2 && v3) {
          if (this.password2 != this.password3) {
            message.showMessage(this, this.$router.lang.get('確認新密碼不一致'))
            return false
          }
          else if (this.password == this.password2) {
            message.showMessage(this, this.$router.lang.get('新老密碼完全一致'))
            return false
          }
          return true
        }
        return false
      }
      if (this.currentTab == 2) {
        let v1 = await this.$refs.realname.validateValue(this.realname)
        let v2 = await this.$refs.idcard.validateValue(this.idcard)
        return v1 &&  v2
      }
      return true
    },
    async submit (data) {
      if (await this.validate()) {
        let _this = this
        this.loading = true
        request.put('/users/me', data, this).then(function (res) {
            if (res.status == 200) {
              _this.screenState.user = res.data
              window.localStorage.setItem('user_info', JSON.stringify(res.data))
              if (_this.$route.query.back) {
                _this.$router.replace(_this.$route.query.back)
              }
              else {
                message.showMessage(_this, _this.$router.lang.get('修改成功'), 'success')
                _this.goCurrentTab(0)
                _this.editDetail(0)
              }
            }
            else if (res.status == 404) {
                window.localStorage.removeItem('token')
                window.localStorage.removeItem('user_info')
                _this.$router.push('/account/login')
            }
            else {
              message.resMessage(res, _this)
            }
            _this.loading = false
        })
      }
    },
    async verifyCode (data) {
      if (await this.validate()) {
        let _this = this
        this.loading = true
        request.post('/verify', data, this).then(function (res) {
            if (res.status == 200) {
              if (data.verify_source == 2) {
                if (_this.screenState.user.email == _this.screenState.user.username)
                  _this.screenState.user.username = data.email
                _this.screenState.user.email = data.email
                _this.email = ''
                _this.emailCode = ''
              }
              else if (data.verify_source == 1) {
                _this.screenState.user.phone = data.phone
                _this.screenState.user.areacode = data.areacode
                _this.phone = ''
                _this.areacode = '66'
                _this.code = ''
                if (data.username) {
                  _this.screenState.user.username = data.username
                  _this.username = ''
                }
                _this.usernameChange = false
              }
              window.localStorage.setItem('user_info', JSON.stringify(_this.screenState.user))
              message.showMessage(_this, _this.$router.lang.get('修改成功'), 'success')
              _this.goCurrentTab(0)
              _this.editDetail(0)
            }
            else {
              message.resMessage(res, _this)
            }
            _this.loading = false
        })
      }
    },
    async changePassword () {
        let validated = await this.validate()
        if (this.tabs2[this.currentTab2] == this.$router.lang.get('手機'))
            validated = validated && await this.$refs.smsPhone.validateValue()
        else
            validated = validated && await this.$refs.smsEmail.validateValue()
        if (validated) {
          let data = {
            verify_type: 4,
            user: this.screenState.user.id,
            password: pwHash(this.password2),
          }
          if (this.tabs2[this.currentTab2] == this.$router.lang.get('手機')) {
            data.phone = this.screenState.user.phone
            data.areacode = this.screenState.user.areacode
            data.verify_source = 1
            data.code = this.codeChangePassword
          }
          else {
            data.email = this.screenState.user.email
            data.verify_source = 2
            data.code = this.emailCodeChangePassword
          }
          this.loading = true
          let _this = this
          request.post('/verify/password', data).then(function (res) {
              if (res.status == 200) {
                _this.$router.replace('/account/login')
              }
              else {
                message.resMessage(res, _this)
              }
              _this.loading = false
          })
        }
    },
    goCurrentTab(index) {
      this.currentTab = index
    },
    async checking (field) {
      this[field] = !this[field]
      if (this.isCollapse) {
        console.log({ads: this.ads, ads_phone: this.ads_phone})
        await this.submit({ads: this.ads, ads_phone: this.ads_phone})
      }
    },
    nextInput (next) {
      next.focus()
    },
    newEmailValidator (str) {
      if (str == this.screenState.user.email)
        return this.$router.lang.get('新舊信箱完全一樣')
      return this.emailValidator(str)
    },
    async changePhone () {
      let v1 = await this.validate()
      let v2 = await this.$refs.phoneOld.validateValue()
      if (v1 && v2) {
        let _this = this
        this.loading = true
        let data = {
          new_phone: {
            code: this.code, areacode: this.areacode,
            phone: this.phone.replace(/^0/, ''), verify_source: 1, verify_type: 2
          },
          old_phone: {
            code: this.codeOld, areacode: this.screenState.user.areacode,
            phone: this.screenState.user.phone, verify_source: 1, verify_type: 2
          },
        }
        if (this.username) {
          data.username = this.username
        }
        request.post('/verify/phone', data, this).then(function (res) {
            if (res.status == 200) {
              _this.screenState.user.phone = data.new_phone.phone
              _this.screenState.user.areacode = data.new_phone.areacode
              _this.phone = ''
              _this.areacode = '66'
              _this.code = ''
              _this.codeOld = ''
              if (data.username) {
                _this.screenState.user.username = data.username
                _this.username = ''
              }
              _this.usernameChange = false
              window.localStorage.setItem('user_info', JSON.stringify(_this.screenState.user))
              message.showMessage(_this, _this.$router.lang.get('修改成功'), 'success')
              _this.goCurrentTab(0)
              _this.editDetail(0)
            }
            else {
              message.resMessage(res, _this)
            }
            _this.loading = false
        })
      }
    },
    async changeEmail () {
      let v1 = await this.validate()
      let v2 = await this.$refs.emailOld.validateValue()
      if (v1 && v2) {
        let _this = this
        this.loading = true
        let data = {
          new_email: {
            code: this.emailCode, email: this.email,
            verify_source: 2, verify_type: 3
          },
          old_email: {
            code: this.emailCodeOld, email: this.screenState.user.email,
            verify_source: 2, verify_type: 3
          },
        }
        request.post('/verify/email', data, this).then(function (res) {
            if (res.status == 200) {
                if (_this.screenState.user.email == _this.screenState.user.username)
                  _this.screenState.user.username = data.new_email.email
                _this.screenState.user.email = data.new_email.email
                _this.email = ''
                _this.emailCode = ''
                _this.emailCodeOld = ''
              window.localStorage.setItem('user_info', JSON.stringify(_this.screenState.user))
              message.showMessage(_this, _this.$router.lang.get('修改成功'), 'success')
              _this.goCurrentTab(0)
              _this.editDetail(0)
            }
            else {
              message.resMessage(res, _this)
            }
            _this.loading = false
        })
      }
    },
    copyCode (code) {
      if (code == '敬請期待') {
        message.showMessage(this, '敬請期待', 'success')
      }
      else {
        let clipboard = new Clipboard('#butt' + code)
        let _this = this
        clipboard.on('success', () => {
          message.showMessage(_this, _this.$router.lang.get('復制成功'), 'success')
          clipboard.destroy();
        })
        clipboard.on('error', () => {
          clipboard.destroy()
        })
      }
    },
  },
  watch: {
    currentTab(val) {
      if (val == 3) {
        let _this = this
        request.get('/promocodes', {limit: 99999999}).then(function (res) {
            if (res.status == 200) {
              let promoCodes = res.data.results.reduce(function (res, x) {
                  if (x.serial)
                      res[0].push(x)
                  else
                    res[1].push(x)
                  return res
              }, [[], []])
                _this.promoCodes = promoCodes[0]
                _this.promoCodes2 = promoCodes[1]
            }
            else {
              message.resMessage(res, _this)
            }
            _this.loading = false
        })
      }
      else if (val == 1) {
          this.tabs2 = []
        if (this.screenState.user && this.screenState.user.phone)
            this.tabs2.push(this.$router.lang.get('手機'))
        if (this.screenState.user && this.screenState.user.email)
            this.tabs2.push(this.$router.lang.get('信箱'))
      } 
    },
  },
  mounted () {
    if (this.$route.query.tab) {
      let currentTab = parseInt(this.$route.query.tab)
      if (currentTab >= 0 && currentTab <= 3)
        this.currentTab = currentTab
    }
  }
};
</script>

<style>
.collapse .account-container .pang-tab > div {
    max-width: 140px;
    font-size: calc(1.5vw + 4.5px);
}

.account-container .pang-tab > div {
    max-width: 140px;
}

.tab2-container {
    margin-bottom: 40px;
}

.tab2-container .pang-tab {
    display: block;
}

.promotion {
    margin-bottom: 40px;
}

.gift-spliter {
    margin-top: 40px;
    color: #686A6E;
    font-size: 18px;
    border-left: 3px solid #C6A86C;
    padding-left: 10px;
}

.tab2-container .pang-tab > div {
    width: 120px;
    height: 30px;
    border-radius: 14px;
    line-height: 30px;
    text-align: center;
    margin-right: 20px;
    font-size: 14px;
    margin-top: 22px;
    display: inline-block;
}

.tab2-container .pang-tab > .inactive {
    border: 1px solid #A3A3A3;
    color: #67696D;
}

.tab2-container .active {
    background-color: #C5A76C;
    color: #FFFFFF;
    border: none;
}

</style>

<style scoped>

.account-container {
  width: 90vw;
  max-width: 824px;
  margin-left: auto;
  margin-right: auto;
  color: #999999;
}

.detail-container {
  display: flex;
  line-height: 53px;
}

.detail-label {
  width: 91px;
}

.detail {
  margin-top: 24px;
  padding-bottom: 100px;
}

.detail-content {
  max-width: 653px;
  width: calc(90vw - 171px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-butt {
  width: 80px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  margin-top: 11px;
  background-color: #C6A86C;
  border-radius: 15px;
  color: #FFFFFF;
  cursor: pointer;
}

.checkbox {
  margin-left: 91px;
  display: flex;
}

.checkbox > label{
    cursor: pointer;
    line-height: 30px;
    height: 30px;
    display: inline-block;
    margin: 3px 10px;
}

.input-label {
  width: calc(6.5vw + 139.5px);
}

.account-collapse .input-label {
  width: calc(6.5vw + 89.5px);
}

.input-container {
  width: calc(90vw - 6.5vw - 139.5px);
  max-width: calc(804px - 6.5vw);
  line-height: 24px;
}

.account-collapse .input-container {
  width: calc(85vw - 103px);
}

.password {
  margin-top: 10px;
  margin-bottom: 100px;
}

.password-container {
  display: flex;
  line-height: 46px;
  margin-bottom: 33px;
}

.butt-container {
  display: flex;
}

.butt-container > div {
  max-width: 280px;
  width: calc(45vw - 20px);
  margin: 0 auto;
}

.butt-container > div:first-child {
  margin-right: 11px;
}

.butt-container > div:first-child > button {
  background-color: #C6C9CE;
}

.butt-container > div:last-child {
  margin-left: 12px;
}

.detail-sumit-butt {
  margin-top: 90px;
}

.no-margin-bottom {
  margin-bottom: 0px;
}

.nickname-hint {
color: #939393;
line-height: 30px;
margin: 5px 0 30px 104px;
}

.promo-item {
  min-height: 170px;
  max-width: 360px;
  width: 45vw;
  background: #FFFFFF;
  border: 1px solid #F9FAFD;
  border-radius: 4px;
  margin: 68px 23px 0 0;
  display: inline-block;
}

.higher {
    padding-bottom: 10px;
}

.pin-label {
    width: 45px;
    display: inline-block;
}

.promo-detail {
  width: 310px;
  margin-left: 25px;
  padding-bottom: 16px;
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.promo-num {
  display: flex;
  margin: 12px 0 0 25px;
  line-height: 26px;
  font-size: 14px;
  color: #80777C;
}

.promo-img img {
  width: 115px;
  height: 114px;
  margin-top: -19px;
}

.promo {
  margin: 22px 0 0 15px;
  width: 70%;
}

.promo-title {
font-size: 22px;
color: #525456;
}

.promo-subtitle {
  margin-top: 10px;
  font-size: 14px;
  color: #999999;
  display: flex;
}

.promo-subtitle img {
  margin-bottom: -1px;
}

.promo-subtitle > div {
  margin-right: auto;
  cursor: pointer;
}

.promo-butt {
  width: 87px;
  height: 26px;
  margin: 0 16px 0 auto;
}

.account-collapse .promo-item {
  width: 90vw;
  max-width: none;
  height: 210px;
  border-radius: 8px;
}

.account-collapse .promo-detail  {
  width: calc(90vw - 50px);
}

.account-collapse .promo-butt {
  width: 60px;
  margin-right: 25px;
}

.account-collapse .promo-num {
  font-size: calc(1vw + 5px);
}

.account-collapse .promo-img img {
  max-width: 115px;
  max-height: 114px;
  width: 30vw;
  height: 30vw;
  min-width: 100px;
  min-height: 100px;
  margin-top: 20px;
}


.logout > div:last-child {
  width: 400px;
  max-width: none;
  margin-left: auto;
  margin-right: auto;
}

.logout {
    display: block;
}

.account-collapse .logout > div:last-child {
  width: calc(90vw - 40px);
  max-width: none;
}

.no-data {
    font-size: 40px;
    text-align: center;
    margin-top: 150px;
    color: #A8AEB3;
}
</style>